import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';

import TextField from '../text_field/text_field';
import './add-product-form.css';
import { addVariantsToCart, productVariantFromBase64String } from '../utilities';

var AddProductForm = function (_Component) {
	_inherits(AddProductForm, _Component);

	function AddProductForm() {
		_classCallCheck(this, AddProductForm);

		var _this = _possibleConstructorReturn(this, (AddProductForm.__proto__ || Object.getPrototypeOf(AddProductForm)).call(this));

		_this.state = {
			add_to_cart_text: "Add To Cart +",
			add_to_cart_classes: "button"
		};
		return _this;
	}

	_createClass(AddProductForm, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    disclaimer = _props.disclaimer,
			    updateValue = _props.updateValue,
			    quantity = _props.quantity,
			    totalPrice = _props.totalPrice,
			    selectedVariantId = _props.selectedVariantId,
			    currency = _props.currency;
			var _state = this.state,
			    add_to_cart_text = _state.add_to_cart_text,
			    add_to_cart_classes = _state.add_to_cart_classes;

			return React.createElement(
				'div',
				{ className: 'wrapper-small add-product-form' },
				React.createElement(
					'div',
					null,
					React.createElement(TextField, {
						title: 'quantity',
						required: true,
						itemAction: updateValue,
						fieldType: 'number',
						initialValue: quantity,
						min: '1'
					}),
					React.createElement(
						'p',
						{ className: 'price-container' },
						React.createElement(
							'span',
							{ className: 'price' },
							'$',
							totalPrice
						),
						React.createElement(
							'span',
							{ className: 'currency' },
							currency
						)
					),
					React.createElement(
						'button',
						{ className: add_to_cart_classes, onClick: function onClick() {
								addVariantsToCart([{ quantity: parseInt(quantity), id: productVariantFromBase64String(selectedVariantId) }]);_this2.setState({ add_to_cart_classes: 'button disabled' });_this2.setState({ add_to_cart_text: 'Added to Cart :)' });
							} },
						add_to_cart_text
					)
				),
				React.createElement(
					'div',
					null,
					React.createElement(
						'p',
						null,
						disclaimer.text
					)
				)
			);
		}
	}]);

	return AddProductForm;
}(Component);

export default AddProductForm;